<template>
	<div style="width: 80%; margin: 30px 10% 80px;">
		<div class="hdyy-details-top">
			<div class="hdyy-details-top-left">
				<img src="../../../static/hdyy_1.png" alt="">
			</div>
			<div class="hdyy-details-top-right">
				<div class="title">
					【活动即将开始】— 郑成功收费台湾之战
				</div>
				<div class="hdyy-details-top-right-middle">
					<div>
						时间：2016年08/08  上午10：00
					</div>
					<div>
						主办单位：海军博物馆
					</div>
					<div>
						地点：青岛市海军博物馆ABCD区
					</div>
				</div>

				<div class="yy-button">
					立即预约
				</div>
			</div>
		</div>
		<div class="news-title">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				【活动预告】— 郑成功收费台湾之战
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="news-xinxi">
			<div>
				时间：2016年10/08  上午10：00
			</div>
			<div style="margin-left: 45px;">
				主办单位：中国人民解放军海军博物馆
			</div>
		</div>
		<div style="text-align: left; font-size: 13px; color: #333333;">
			<p>
				661年3月21日，郑成功率军25000人、战船数百艘，从金门渡海，进攻台湾。30日午后，郑成功巧妙地渡过了荷兰人未设防的水道，包围了荷兰人防守的赤嵌城，击沉荷兰人的主力舰，在台湾登陆。荷军多次反扑均遭失败，于次年2月1日宣布投降...
			</p>
			<p style="margin-top: 10px;">
				郑成功水军所创立的赫赫战功，将永远镌刻在中华民族的光辉史册上661年3月21日，郑成功率军25000人、战船数百艘，从金门渡海，进攻台湾。30日午后，郑成功巧妙地渡过了荷兰人未设防的水道，包围了荷兰人防守的赤嵌城，击沉荷兰人的主力舰，在台湾登陆。荷军多次反扑均遭失败，于次年2月1日宣布投降...
			</p>
			<p style="margin-top: 10px;">
				郑成功水军所创立的赫赫战功，将永远镌刻在中华民族的光辉史册上城，击沉荷兰人的主力舰，在台湾登陆。荷军多次反扑均遭失败，于次年2月1日宣布投降...
			</p>
			<p style="margin-top: 10px;">
				郑成功水军所创立的赫赫战功，将永远镌刻在中华民族的光辉史册上
			</p>
		</div>
		<div class="back">
			<div class="back-button" @click="$router.back(-1)">
				返回列表
			</div>
		</div>
		<div class="news-title">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px; font-size: 20px;">
				活动场景
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="hdcj-list">
			<img src="../../../static/hdyy_details_1.png" alt="">
			<img src="../../../static/hdyy_details_2.png" alt="">
			<img src="../../../static/hdyy_details_3.png" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				newsId: "",
				details: {
					hd_id: ''
				},
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.hd_id = this.$route.query.hd_id
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_4.png'
		},
		methods: {
			backToList() {
				this.router.back(-1)
			}
		}
	}
</script>

<style lang="less" scoped>
	.hdyy-details-top {
		width: 100%;
		height: 100%;
		display: flex;
		.hdyy-details-top-left {
			width: 55%;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.hdyy-details-top-right {
			width: 45%;
			border: 3px solid #EDD68E;
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			text-align: left;
			padding: 0 20px;
			color: #686868;
			font-size: 12px;
			.title {
				color: #922627;
				font-size: 13px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.hdyy-details-top-right-middle {
				height: 38%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}
			.yy-button {
				width: 50%;
				height: 40px;
				line-height: 40px;
				text-align: center;
				background-color: #264EA7;
				color: #FFFFFF;
			}
		}
	}
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
	.news-xinxi {
		width: 100%;
		height: 70px;
		line-height: 70px;
		display: flex;
		color: #686868;
		font-size: 11px;
		justify-content: space-around;
	}
	.back {
		position: relative;
		margin: 30px 0;
		height: 20px;
		.back-button {
			position: absolute;
			width: 75px;
			height: 20px;
			line-height: 20px;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			right: 28px;
			cursor: pointer;
		}
	}
	.hdcj-list {
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-top: 30px;
		img {
			width: 33%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/teaching_activities/hdyy_details.vue